import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { track } from "@/lib/analytics";
import { consumeRef } from "@/lib/referral";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = (location.hash || "").match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/session", {
          session_id: match[1],
          referrer_code: consumeRef() || undefined,
        });
        setUser(r.data);
        track("signup", { email_domain: r.data.email?.split("@")[1] });
        window.history.replaceState(null, "", "/projects");
        navigate("/projects", { state: { user: r.data } });
      } catch {
        navigate("/login");
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="overline">Establishing session</div>
        <div className="font-display text-2xl mt-2">Signing you in…</div>
      </div>
    </div>
  );
};
